import {UIDHeaderController} from '../../../ui_html/header/UIDHeaderController.ts'
import {UIWHeaderController} from '../../../ui_html/header/UIWHeaderController.ts'
import {UIDStoreController} from '../../../store/UIDStoreController.ts'
import {ViewPopupRewardsProgram} from '../../../ui_popup/ViewPopupRewardsProgram.ts'
import {ShareActivityLinkAnalytics} from '../../../../../../shared/entity_datas/EntityDatas.ts'

export class UIDStoreSceneController {
    private readonly headerController: UIWHeaderController
    private readonly storeSceneContainerDiv: HTMLDivElement
    readonly storeController: UIDStoreController

    constructor(headerController: UIWHeaderController) {
        this.headerController = headerController
        this.storeSceneContainerDiv = document.getElementById('scene_discord_store_container') as HTMLDivElement
        this.storeController = new UIDStoreController()
    }

    hide() {
        this.storeSceneContainerDiv.classList.add('hidden')
    }

    show(hash?: string, value?: string) {
        this.storeSceneContainerDiv.classList.remove('hidden')

        if(this.headerController instanceof UIDHeaderController) this.headerController.activateStoreButton()

        if(!UIDStoreSceneController.shouldShowDiscordShareActivityLinkPopup(hash, value)) return

        const abTestAnalytics = UIDStoreSceneController.getAbTestPushReferrersToInviteMoreFriendsAnalytics(value)
        if(abTestAnalytics == undefined) return

        ViewPopupRewardsProgram.showDiscordShareActivityLinkPopup(abTestAnalytics.popupTriggered, abTestAnalytics.successfullyShared)
    }

    private static shouldShowDiscordShareActivityLinkPopup(hash?: string, value?: string): boolean {
        if(hash != 'referrals') return false
        if(value?.includes('showpopup') == false) return false
        return true
    }

    private static getAbTestPushReferrersToInviteMoreFriendsAnalytics(value?: string): {
        popupTriggered: ShareActivityLinkAnalytics
        successfullyShared: ShareActivityLinkAnalytics
    } | undefined {
        if(value?.includes('groupa') == true) {
            return {
                popupTriggered: ShareActivityLinkAnalytics.ABTestPushReferrersToInviteMorePlayersGroupAPopupTriggered,
                successfullyShared: ShareActivityLinkAnalytics.ABTestPushReferrersToInviteMorePlayersGroupASuccessfullyShared,
            }
        }
        if(value?.includes('groupb') == true) {
            return {
                popupTriggered: ShareActivityLinkAnalytics.ABTestPushReferrersToInviteMorePlayersGroupBPopupTriggered,
                successfullyShared: ShareActivityLinkAnalytics.ABTestPushReferrersToInviteMorePlayersGroupBSuccessfullyShared,
            }
        }
        if(value?.includes('groupc') == true) {
            return {
                popupTriggered: ShareActivityLinkAnalytics.ABTestPushReferrersToInviteMorePlayersGroupCPopupTriggered,
                successfullyShared: ShareActivityLinkAnalytics.ABTestPushReferrersToInviteMorePlayersGroupCSuccessfullyShared,
            }
        }
        return undefined
    }
}
